import { render, staticRenderFns } from "./CodeDiff.vue?vue&type=template&id=024045f0"
import script from "./CodeDiff.vue?vue&type=script&lang=js"
export * from "./CodeDiff.vue?vue&type=script&lang=js"
import style0 from "./CodeDiff.vue?vue&type=style&index=0&id=024045f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports